<template>
	<div ref="content" class="content background2 searchBox3">
		<div class="userNavBox">
			<div class="navSearch">
				<div class="searchBox-black">
					<label class="searchBox-label">客户名称</label>
					<div class="searchBox-condition" style="width: 150px">
						<!-- <el-select class="select-class" v-model="searchList.customerName" placeholder="请选择">
						  <el-option :label="'全部'" :value="''"></el-option>
						  <el-option v-for="item in customerList" :key="item.id" :label="item.name" :value="item.id">
						  </el-option>
						</el-select> -->
						<el-input class="input-class el-input" v-model="searchList.customerName"></el-input>
					</div>
				</div>
				<!-- <div class="searchBox-black">
					<label class="searchBox-label">所属区域</label>
					<div class="searchBox-condition" style="width: 150px">
						<el-select class="select-class" v-model="searchList.city" placeholder="请选择">
							<el-option :label="'全部'" :value="''"></el-option>
							<el-option v-for="item in provinceList" :key="item.name" :label="item.name" :value="item.name">
							</el-option>
						</el-select>
					</div>
				</div> -->
				<div class="searchBox-black">
					<label class="searchBox-label">时间</label>
					<div class="searchBox-condition">
						<el-date-picker v-model="searchDate" type="daterange" range-separator="至"
							start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
						</el-date-picker>
					</div>
				</div>
				<div class="searchButton" @click="search({pageNo: 1,pageSize: pageSize})">查询</div>
			</div>
			<div class="navTable">
				<div class="tableTitle">
					<p class="title">详细内容</p>
					<excel-export :filename="utils.getNowFormatDate() + '报警时间分布统计表' " :sheet="sheet">
						<!-- <div class="exportButton" v-if="this.menuList.indexOf('CD_511') != -1"> -->
						<div class="exportButton" @click="getExcelList()" v-if="menuList.indexOf('CD_531') != -1">
							导出
						</div>
					</excel-export>
				</div>

				<div class="tableBox list" ref="tableList" :style="{'padding-top':paddingTop}">
					<List ref="list" :tableData="tableData" :tableList="tableList" :pageSize="pageSize" :pageNo="pageNo"
						:checkBox="true" @parentMethod="getInfo" @checkMethod="getCheckInfo"></List>
				</div>
				<div ref="page" class="page">
					<Page ref="pageModel" :total="pageCount" :display="pageSize" :pagegroup="3" :currentspage="1"
						@parentMethod="search"></Page>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import "@/assets/css/common/list.css"
	import SearchList from "@/components/list/searchList";
	import BtnList from "@/components/list/btnList";
	import List from "@/components/list/list";
	import Page from "@/components/common/page";
	import CommonJs from "@/assets/js/common/common.js";
	import staListJs from "@/assets/js/sticList/stic.js";
	export default {
		name: 'alarmTime',
		components: {
			List,
			SearchList,
			BtnList,
			Page
		},
		data() {
			const $this = this;
			return {
				paddingTop: 0,
				value1: '',
				searchDate: '',
				options: [],
				provinceList: [],
				workloadList: [],
				ExcelList: [],
				customerList: [],
				tableList: [{
					column: 'classes',
					title: '班次',
					headerAlign: 'center',
					align: 'center',
					width: '20%'
				}, {
					column: 'customerName',
					title: '客户名称',
					headerAlign: 'center',
					align: 'center',
					width: '20%'
				}, {
					column: 'address',
					title: '所属区域地址',
					headerAlign: 'center',
					align: 'center',
					width: '20%'
				}, {
					column: 'error',
					title: '报警类型',
					headerAlign: 'center',
					align: 'center',
					width: '20%',
					termList: [{
							id: "0",
							name: '传感器故障'
						},
						{
							id: "1",
							name: '主机故障'
						},
						{
							id: "2",
							name: '设备掉线'
						},
						{
							id: "3",
							name: '浓度超限'
						},
						{
							id: "4",
							name: '传感器寿命到期'
						},
						{
							id: "5",
							name: '维保将到期'
						},
						{
							id: "6",
							name: '探测器校准'
						},
						{
							id: "7",
							name: '主机声光报警'
						},
						{
							id: "8",
							name: '联动器报警'
						},
						{
							id: "9",
							name: '通讯故障'
						}
					],
				}, {
					column: 'content',
					title: '报警原因',
					headerAlign: 'center',
					align: 'center',
					width: '20%'
				}],
				multipleSelection: [],
				tableData: [],
				menuList: [],
				checkboxList: [],
				tableInfo: {},
				searchList: {
					user: '',
					customerName: '',
					time1: '',
					time2: '',
					city: '',
					district: '',
				},
				sheet: [{
					title: "报警时间分布统计表",
					tHeader: [
						"班次",
						"客户名称",
						"所属区域地址",
						"报警类型",
						"报警原因",
					],
					keys: [
						"classes",
						"customerName",
						"address",
						"error",
						"content",
					],
					table: [],
					sheetName: "报警时间分布统计",
					cellStyle: [{
						cell: "A1",
						font: {
							name: "黑体",
							sz: "18px",
						},
					}],
				}],
				pageCount: 0,
				pageSize: 0,
				pageNo: 1,
			}
		},
		methods: {
			test(item) {
				if (item.district != null) {
					this.searchList.district = item.district;
				} else if (item === 'all') {
					this.searchList.city = '';
				} else {
					this.searchList.city = item;
				}
				this.search({
					pageNo: 1,
					pageSize: this.pageSize
				});
			},
			// queryArea(item) {
			// 	console.log(item)
			// 	let param = {
			// 		pageNo: 1,
			// 		pageSize: this.pageSize,
			// 	};
			// 	if (item == "all") {
			// 		this.$delete(this.searchParam, "city");
			// 		this.$delete(this.searchParam, "district");
			// 		param = Object.assign(param, item);
			// 		console.log(param);
			// 		this.search(param);
			// 	} else {
			// 		this.$delete(this.searchParam, "city");
			// 		this.$delete(this.searchParam, "district");
			// 		param = Object.assign(param, item);
			// 		this.searchParam = Object.assign(this.searchParam, item);
			// 		console.log(param);
			// 		this.search(param);
			// 	}
			// },
			search(param) {
				this.searchList.time1 = this.searchDate ? this.searchDate[0] || '' : '';
				this.searchList.time2 = this.searchDate ? this.searchDate[1] || '' : '';
				var newParam = Object.assign(param, this.searchList);
				this.getProcessingTimeDistributionStatistics(newParam)
				this.searchList.district = '';
			},
			getExcelList() { //导出
				// this.searchList.time1 = this.searchDate ? this.searchDate[0] || '' : '';
				// this.searchList.time2 = this.searchDate ? this.searchDate[1] || '' : '';
				// this.searchList.user = this.checkboxList.join();
				// var newParam = Object.assign(this.searchList);
				// staListJs.getProcessingTimeDistributionStatisticsList(newParam)
				// 	.then((response) => {
				// 		const data = response.data;
				// 		if (data.code == 1) {
				var list = [];
				var $this = this;
				this.ExcelList.forEach(function(item, index) {
					var newItem = {};
					newItem.classes = item.classes == null ? " " : item.classes;
					newItem.customerName = item.customerName == null ? " " : item.customerName;
					newItem.address = item.address == null ? " " : item.address;
					newItem.error = item.error == null ? " " : item.error;
					newItem.content = item.content == null ? " " : item.content;
					list.push(newItem);
				});
				this.sheet[0].table = list;
				// 	}
				// })
				// .catch((response) => {});
			},
			getaddr() {
				staListJs.getaddr().then((response) => {
					const data = response.data;
					this.supportPersonList = data.data;
					var array = [];
					for (var i = 0; i < this.supportPersonList.length; i++) {
						array.push(this.supportPersonList[i].province);
					}
					var temp = [];
					var index = [];
					var l = array.length;
					for (var i = 0; i < l; i++) {
						for (var j = i + 1; j < l; j++) {
							if (array[i] === array[j]) {
								i++;
								j = i;
							}
						}
						temp.push(array[i]);
						index.push(i);
					}
					let list = [];
					for (var i = 0; i < temp.length; i++) {
						list.push({
							// id: this.provinceList[i].id.toString(),
							name: temp[i],
						});
					}
					this.provinceList = list;
				});
			},
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			getInfo(info) {
				this.tableInfo = info;
			},
			getCheckInfo(info) {
				this.checkboxInfo = info;
				this.checkboxList = [];
				for (var i = 0; i < this.checkboxInfo.length; i++) {
					this.checkboxList.push(this.checkboxInfo[i].id)
				}
				this.searchList.time1 = this.searchDate ? this.searchDate[0] || '' : '';
				this.searchList.time2 = this.searchDate ? this.searchDate[1] || '' : '';
				this.searchList.user = this.checkboxList.join();
				var newParam = Object.assign(this.searchList);
				staListJs.getProcessingTimeDistributionStatisticsList(newParam)
					.then((response) => {
						const data = response.data;
						this.ExcelList = data.data
					})
					.catch((response) => {});
			},
			getUserBy() {
				staListJs.getCustomerName().then((response) => {
					const data = response.data;
					this.supportPersonList = data.data;

					let list = [];
					for (var i = 0; i < this.supportPersonList.length; i++) {
						list.push({
							id: this.supportPersonList[i].id.toString(),
							name: this.supportPersonList[i].customerName,
						});
					}
					this.customerList = list;
				});
			},
			getProcessingTimeDistributionStatistics(param) {
				staListJs.getProcessingTimeDistributionStatistics(param).then((response) => {
					const data = response.data;
					if (data.code == "1") {
						this.tableData = data.data.records;
						this.pageCount = data.data.total;
						this.pageNo = data.data.current;

					}
				});
			},
			getWindowHeight() {
				let height = '';
				height = this.$refs.tableList.clientHeight - 220;
				this.height = height;
				if (height > 550) {
					let line = parseInt((height - 10) / 50);
					if (this.pageSize != line) {
						this.pageSize = line;
					}
				} else {
					if (this.pageSize != 10) {
						this.pageSize = 10;
					}
				}
				this.search({
					pageNo: 1,
					pageSize: this.pageSize
				});
			},
		},
		created() {
			this.menuList = this.$store.getters.getMenuPermission;
			var a = [];
			a.push(new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 6))
				.toISOString().slice(
					0, 10));
			a.push(new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())).toISOString()
				.slice(
					0, 10));
			this.searchDate = a;
		},
		mounted() {
			this.paddingTop = '140px';
			this.getWindowHeight();
			window.onresize = () => {
				this.$refs.list.getHeight();
				this.getWindowHeight();
			}
			this.getUserBy();
			this.getaddr();
			window.test = this.test;
		}
	}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/statisticsList/alarmTime.vue